<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Médico</h4>
    <hr />
    <!-- Modal -->
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-primary">
          <h5 class="modal-title" id="exampleModalLabel">
            <i class="fa fa-user-plus"></i> {{ titulo }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <form>
          <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idMedico" class="form-label">IdMedico</label>
                </div>
                <div class="col-10">
                  <input
                    type="text"
                    class="form-control"
                    id="idMedico"
                    name="idMedico"
                    v-model="datoMedico.idMedico"
                    disabled
                  />
                </div>
              </div>
            </div>
            <!-- Botón Lista de Valores  Persona -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idPersona" class="form-label"> Persona</label>
                </div>
                <div class="col-10">
                  <select
                    class="form-control"
                    id="idPersona"
                    name="idPersona"
                    v-model="datoMedico.idPersona"
                    disabled
                  >
                    <option
                      v-for="persona in personas"
                      :value="persona.idPersona"
                      :key="persona.idPersona"
                    >
                      {{ persona.nombreCompleto }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <!-- Botón Lista de Valores  Persona -->
            <!-- Botón Lista de Valores  Especialidad -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idEspecialidad" class="form-label">
                    Especialidad</label
                  >
                </div>
                <div class="col-10">
                  <select
                    class="form-control"
                    id="idEspecialidad"
                    name="idEspecialidad"
                    v-model="datoMedico.idEspecialidad"
                  >
                    <option
                      v-for="especialidad in especialidads"
                      :value="especialidad.idEspecialidad"
                      :key="especialidad.idEspecialidad"
                    >
                      {{ especialidad.nombre }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <!-- Botón Lista de Valores  Especialidad -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="documento" class="form-label">Documento</label>
                </div>
                <div class="col-10">
                  <input
                    type="text"
                    class="form-control"
                    id="documento"
                    name="documento"
                    v-model="datoMedico.documento"
                    style="text-transform: uppercase"
                    required
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="modal-footer">
          <!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
          <button
            type="submit"
            class="btn btn-light"
            @click.prevent="guardarMedico"
            v-if="btnCrear"
            title="Guardar"
          >
            <i
              class="material-icons"
              style="font-size: 32px; color: blue; cursor: pointer"
              >save</i
            >Guardar
          </button>
          <button
            type="submit"
            class="btn btn-light"
            @click.prevent="actualizarMedico"
            v-if="btnEditar"
            title="Actualizar"
          >
            <i
              class="material-icons"
              style="font-size: 32px; color: blue; cursor: pointer"
              >update</i
            >Actualizar
          </button>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import config from '@/config';
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import dateFormat from "@/modules/dateFormat.js";


import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
export default {
  components: {
    Layout,
    Footer,
  },
  data() {
    return {
      medicos: [],
      datoMedico: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      modalWindow: true,
      p_idMedico: 0,
      personas: [],
      especialidads: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
    };
  },
  mounted() {
    this.p_idMedico = this.$route.params.p_idmedico;
    this.getData();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.fetchPersonas();
    this.fetchEspecialidads();
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    getData() {
      api.get("/vwmedicos/" + this.p_idMedico)
        .then((response) => {
          this.datoMedico = response.data;
        })
        .catch((error) => {
          console.error("Error al obtener datos de la persona:", error);
        });
    },
    async guardarMedico() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/medicos",
            this.datoMedico
          );
          $("#ventanaModal").modal("hide");
          swal("Correcto!", "Medico creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    fetchPersonas() {
      fetch(config.apiBaseUrl + "/vwpersonas")
        .then((response) => response.json())
        .then((data) => {
          this.personas = data;
        })
        .catch((error) => {
          console.error("Error fetching personas:", error);
        });
    },
    fetchEspecialidads() {
      fetch(config.apiBaseUrl + "/especialidads")
        .then((response) => response.json())
        .then((data) => {
          this.especialidads = data;
        })
        .catch((error) => {
          console.error("Error fetching especialidads:", error);
        });
    },
  },
};
</script>
